module.exports = __webpack_public_path__ + "img/iconos5.cd55b006.png";